export const minimalRequirementsSubtaks = [
  {
    description: "a) používání zařízení k účelům, pro které je určeno",
    sub_description: "Je zařízení používáno v souladu s návodem výrobce, MPBP, SOP, …",
    value_description: "Způsob ověření",
    value_unit: "vyberte",
    value_min: null,
    value_max: null,
    position: 1,
    files: [],
  },
  {
    description: "b) bezpečný přístup a dostatečný manipulační prostor",
    sub_description: "Nejsou zataraseny únikové trasy, obslužné plochy, manipulační plochy, …",
    value_description: "Způsob ověření",
    value_unit: "vyberte",
    value_min: null,
    value_max: null,
    position: 2,
    files: [],
  },
  {
    description: "c) přivádění a odvádění všech forem energií bezpečným způsobem",
    sub_description: "Vizuální kontrola energovodů, kabeláž, vzduch, plyn, hydraulika, technické plyny, …",
    value_description: "Způsob ověření",
    value_unit: "vyberte",
    value_min: null,
    value_max: null,
    position: 3,
    files: [],
  },
  {
    description: "d) vybavení zábranou nebo ochranným zařízením",
    sub_description: "Souhlasí bezpečností zábrany, případně ochranné prvky a zařízení s dokumentací.",
    value_description: "Způsob ověření",
    value_unit: "vyberte",
    value_min: null,
    value_max: null,
    position: 4,
    files: [],
  },
  {
    description: "e) montování a demontování zařízení za bezpečných podmínek",
    sub_description: "V souladu s návodem výrobce, SOP, GWP, hrozba cizího napětí, zbytkové energie kondenzátorů, …",
    value_description: "Způsob ověření",
    value_unit: "vyberte",
    value_min: null,
    value_max: null,
    position: 5,
    files: [],
  },
  {
    description: "f) ochrana zaměstnance proti nebezpečnému dotyku u zařízení pod napětím",
    sub_description: "Izolační kryty, izolace, zábrany.",
    value_description: "Způsob ověření",
    value_unit: "vyberte",
    value_min: null,
    value_max: null,
    position: 6,
    files: [],
  },
  {
    description: "g) ochrana zařízení před účinky atmosférické elektřiny",
    sub_description: "Uzemnění, pospojení.",
    value_description: "Způsob ověření",
    value_unit: "vyberte",
    value_min: null,
    value_max: null,
    position: 7,
    files: [],
  },
  {
    description: "h) umístění ovládacích prvků ovlivňujících bezpečnost",
    sub_description: "Označení, stav, dosažitelnost.",
    value_description: "Způsob ověření",
    value_unit: "vyberte",
    value_min: null,
    value_max: null,
    position: 8,
    files: [],
  },
  {
    description: "i) spouštění zařízení obsluhou pomocí ovládače",
    sub_description: "Kontrola ovládacích prvků stroje, popis ovládacích prvků.",
    value_description: "Způsob ověření",
    value_unit: "vyberte",
    value_min: null,
    value_max: null,
    position: 9,
    files: [],
  },
  {
    description: "j) vybavení ovládačem pro úplné bezpečné zastavení",
    sub_description: "TOTAL STOP",
    value_description: "Způsob ověření",
    value_unit: "vyberte",
    value_min: null,
    value_max: null,
    position: 10,
    files: [],
  },
  {
    description: "k) vybavení ovládačem pro nouzové zastavení",
    sub_description: "CENTRAL STOP",
    value_description: "Způsob ověření",
    value_unit: "vyberte",
    value_min: null,
    value_max: null,
    position: 11,
    files: [],
  },
  {
    description: "l) vybavení zařízením pro odpojení od všech zdrojů energií",
    sub_description: "LOTO",
    value_description: "Způsob ověření",
    value_unit: "vyberte",
    value_min: null,
    value_max: null,
    position: 12,
    files: [],
  },
  {
    description: "m) vybavení pracoviště ovládači k zastavení",
    sub_description: "Jsou vypínací prvky umístěny v místě obsluhy?",
    value_description: "Způsob ověření",
    value_unit: "vyberte",
    value_min: null,
    value_max: null,
    position: 13,
    files: [],
  },
  {
    description: "n) upevnění, ukotvení nebo zajištění zařízení nebo jeho části",
    sub_description: "mech. tuhost, celistvost, nepoškozenost, …",
    value_description: "Způsob ověření",
    value_unit: "vyberte",
    value_min: null,
    value_max: null,
    position: 14,
    files: [],
  },
  {
    description: "o) neohrožování zaměstnance např. hlukem, vibracemi, teplotami atd.",
    sub_description: "hluk, vibrace, dotykové teploty, …",
    value_description: "Způsob ověření",
    value_unit: "vyberte",
    value_min: null,
    value_max: null,
    position: 15,
    files: [],
  },
  {
    description: "p) označení výstražnými nebo informačními značkami, sděleními, atd.",
    sub_description: "informační, příkazové, zákazové značky",
    value_description: "Způsob ověření",
    value_unit: "vyberte",
    value_min: null,
    value_max: null,
    position: 16,
    files: [],
  },
  {
    description: "q) ochranné zařízení a zabezpečení proti ohrožení života a zdraví před padajícími, odlétajícími nebo vymrštěnými předměty",
    sub_description: "mechanické zábrany, clony, …",
    value_description: "Způsob ověření",
    value_unit: "vyberte",
    value_min: null,
    value_max: null,
    position: 17,
    files: [],
  },
  {
    description: "r) ochranné zařízení a zabezpečení proti ohrožení života a zdraví před rizikem požáru nebo výbuchu",
    sub_description: "detektory kouře, aspiranční detekce, EPS tlačítka, …",
    value_description: "Způsob ověření",
    value_unit: "vyberte",
    value_min: null,
    value_max: null,
    position: 18,
    files: [],
  },
  {
    description: "s) ochranné zařízení a zabezpečení proti ohrožení života a zdraví před nebezpečným únikem plynných, kapalných a tuhých látek",
    sub_description: "skladování hořlavin poblíž stroje, uniky olejů, kapalin, záplavová čidla, houkačky, návěstí, …",
    value_description: "Způsob ověření",
    value_unit: "vyberte",
    value_min: null,
    value_max: null,
    position: 19,
    files: [],
  },
  {
    description: "t) ochranné zařízení a zabezpečení proti ohrožení života a zdraví před zraněním způsobeným zachycením pohyblivou částí zařízení",
    sub_description: "zábrany, optické závory, zámky na brankách, …",
    value_description: "Způsob ověření",
    value_unit: "vyberte",
    value_min: null,
    value_max: null,
    position: 20,
    files: [],
  },
]
